import React from "react";
import img1 from "../images/Occasion.1.jpg";
import img2 from "../images/Occasion.jpg";
import img3 from "../images/Occasion.3.jpg";
import img4 from "../images/Occasion.4.jpg";
import img5 from "../images/banner11.jpg";
import img6 from "../images/banner2.jpg";

const Occasion = () => {
  return (
    <div>
      <div className="mt-7">
        <img
          src={img6}
          alt="Occasion Banner"
          className="w-full  lg:hidden block"
        />
      </div>
      <div>
        <img
          src={img5}
          alt="Occasion Banner"
          className="w-full h-[380px] 5xl:h-[500px] 8xl:h-[550px] 10xl:h-[840px] 11xl:h-[930px] hidden lg:block"
        />
      </div>
      <div className="mb-4 px-4  2xl:px-7">
        <h1 className="font-abhaya text-lg md:text-2xl 2xl:text-2xl 4xl:text-4xl 8xl:text-5xl 9xl:text-6xl 10xl:text-7xl 11xl:text-8xl text-center font-bold text-secondary tracking-[4px] 3xl:tracking-[7px] 8xl:tracking-[9px] mb-4 mt-5 8xl:mt-9">
          Shop by Occasion
        </h1>
        <div className="grid grid-cols-2  3xl:grid-cols-4 gap-4 px-4 3xl:px-12 3xl:gap-7 7xl:px-24 7xl:gap-10 justify-center">
          <div>
            <img className="w-full  rounded-t-full border-[3px] border-[#FBB14B]  object-cover" src={img1} alt="Occasion" />
            <div className="bg-[#FBB14B] py-2 md:py-4 8xl:py-8 text-center">
              <h2 className="font-bellefair xs:text-xl md:text-2xl 9xl:text-4xl 10xl:text-5xl 11xl:text-7xl">Wedding</h2>
              <p className="text-sm md:text-lg 9xl:text-xl 10xl:text-3xl 11xl:text-5xl 8xl:mt-2">Starting Price</p>
              <p className="xs:text-xs font-sans  md:text-lg 2xl:text-xl 10xl:text-2xl 11xl:text-5xl 8xl:mt-2 10xl:mt-4">₹15000 </p>
            </div>
          </div>
          <div>
            <img className="w-full rounded-t-full border-[3px] border-[#FBB14B]  object-cover" src={img2} alt="Occasion" />
            <div className="bg-[#FBB14B] py-2 md:py-4 8xl:py-8 text-center">
              <h2 className="font-bellefair xs:text-xl md:text-2xl 9xl:text-4xl 10xl:text-5xl 11xl:text-7xl">Reception</h2>
              <p className="text-sm md:text-lg 9xl:text-xl 10xl:text-3xl 11xl:text-5xl 8xl:mt-2">Starting Price</p>
              <p className="xs:text-xs md:text-lg font-sans 2xl:text-xl 10xl:text-2xl 11xl:text-5xl 8xl:mt-2 10xl:mt-4">₹12500</p>
            </div>
          </div>
          <div>
            <img className="w-full rounded-t-full border-[3px] border-b border-[#FBB14B] object-cover" src={img3} alt="Occasion" />
            <div className="bg-[#FBB14B] py-2 md:py-4 8xl:py-8 text-center">
              <h2 className="font-bellefair xs:text-xl md:text-2xl 9xl:text-4xl 10xl:text-5xl 11xl:text-7xl">House Warming</h2>
              <p className="text-sm md:text-lg 9xl:text-xl 10xl:text-3xl 11xl:text-5xl 8xl:mt-2">Starting Price</p>
              <p className="xs:text-xs md:text-lg font-sans 2xl:text-xl 10xl:text-2xl 11xl:text-5xl 8xl:mt-2 10xl:mt-4">₹7200</p>
            </div>
          </div>
          <div>
            <img className="w-full rounded-t-full border-[3px] border-b border-[#FBB14B] object-cover" src={img4} alt="Occasion" />
            <div className="bg-[#FBB14B] py-2 md:py-4 8xl:py-8 text-center">
              <h2 className="font-bellefair xs:text-xl md:text-2xl 9xl:text-4xl 10xl:text-5xl 11xl:text-7xl">Baby Shower</h2>
              <p className="text-sm md:text-lg 9xl:text-xl 10xl:text-3xl 11xl:text-5xl 8xl:mt-2">Starting Price</p>
              <p className="xs:text-xs md:text-lg font-sans 2xl:text-xl 10xl:text-2xl 11xl:text-5xl 8xl:mt-2 10xl:mt-4">₹6500</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Occasion;
